import * as React from 'react';
import styles from '../styles/wizards/ContactProductSellerWizard.scss';
import MessageSendIcon from '../assets/images/message-send-60x60.svg';
import { __, validateForm } from '../core/utils';
import * as _ from 'lodash';
import { setNotification } from '../redux/actions/general/notification';
import ContactProductSellerForm from '../forms/contact_product_seller_wizard/ContactProductSellerForm';
import { contactProductSeller } from '../redux/actions/table/products';
import connect from 'react-redux/es/connect/connect';

const ContactProductSellerWizard = ({ store, onClose }) => {
  const _handleSubmit = (formData) => {
    const { id } = store.flyout;

    return validateForm(
      contactProductSeller(id, formData).then(() => {
        setNotification(
          __('You have successfully sent a message to the product seller')
        );

        onClose();
      })
    );
  };

  const { flyout } = store;

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{__('products.contact-product-seller-wizard.title')}</span>
          <span>{__('products.contact-product-seller-wizard.subtitle')}</span>
        </div>
        <div className={styles.right}>
          <MessageSendIcon />
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.title}>
          <strong>{'P-' + _.padStart(flyout.id, 4, '0')}:</strong>
          <span>
            {flyout.model} by {flyout.brand}
          </span>
        </div>

        <ContactProductSellerForm
          onSubmit={_handleSubmit}
          initialValues={{
            company_email: flyout.company_email,
          }}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state, props) => {
  return {
    store: state.table.products,
  };
};

export default connect(mapStateToProps, null)(ContactProductSellerWizard);
